<template>
    <v-row>
        <v-col cols="12" justify="center" align="center">
            <div 
                v-if="front" 
                class="py-2 transition paron-card-members text-start px-4" 
                @click="rotation" 
                v-bind:style="{transform: `perspective(600px) rotateY(${deg}deg)`}"
            >
                <div class="ilioupoli-card-text"> 
                    <span>Paron card no. {{ $store.getters.getCard.card }}</span>
                </div>
                <div> 
                    {{ $store.getters.getParonMember.member.vipGroup ? $store.getters.getParonMember.member.vipGroup : 'Simple Member' }}
                </div>
                <div class="mt-2">
                    <span class="faded-bg">
                        Name: {{ $store.getters.getFirstName.firstName + ' ' + $store.getters.getLastName.lastName }}
                    </span>
                </div>
                <div class="mt-2">
                    <span class="faded-bg">
                        IKEA Loyalty: 3000000113868
                    </span>
                </div>
            </div>
            <div 
                v-else
                class="py-4 transition paron-card-back-members" 
                @click="rotation" 
                v-bind:style="{transform: `perspective(600px) rotateY(${deg}deg)`}"
            >
                <div class="ilioupoli-card-text faded-bg" >ΑΦΜ 801970888</div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        data: () => ({
            deg: 0,
            front: true,
        }),
        methods: {
            getFormatedDate() {
                let objectDate = new Date(this.$store.getters.getExpirationDate.expirationDate)

                let day = objectDate.getDate()

                let month = objectDate.getMonth()

                let year = objectDate.getFullYear()

                return day + "/" + month + "/" + year
            },
            rotation() {
                this.deg += 360
                this.front = !this.front
            }
        }
    }
</script>

<style lang="scss" scoped>

    @media only screen and (min-width: 601px){

        .ilioupoli-card-text {
            margin-top: 60px;
        }
    }


    @media only screen and (max-width: 600px){
        .ilioupoli-card-text {
            margin-top: 90px;
        }
    }

    .transition {
        transition: transform .6s cubic-bezier(0.4, 0.0, 0.2, 1);
    }

    .paron-card-members{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/members/digital_PARON_MEMBERS_CARD-01.png');
        background-position: center;
        background-size: contain;
        font-size: 1rem;
    }

    .paron-card-back-members{
        max-width: 500px;
        height: 320px;
        background-color: white;
        background-image: url('../assets/members/digital_PARON_MEMBERS_CARD-02.png');
        background-position: center;
        background-size: contain;
    }
    .faded-bg{
        background-color: rgba(255,255,255,0.6);
        border-radius: 4px;
        display: inline-block;
    }
    
</style>